<div class="layout-container">
    <h2 class="heading-lg">About Us</h2>
    <hr>
    <p class="text-block">
        <strong>Funfigz Solution</strong> is a precision-driven manufacturing partner specializing in <strong>high-tolerance plastic 
        injection molding</strong> and <strong> high-volume component production </strong>for industrial and commercial applications. 
        With a strong emphasis on <strong> engineering integrity, process control,</strong> and <strong> repeatability </strong>, we help OEMs 
        and Tier 1 suppliers meet demanding production schedules and exacting quality standards.
        Our production facility is equipped with <strong> state-of-the-art injection molding machines,</strong> capable 
        of handling a wide range of thermoplastics, engineering resins, and multi-cavity tools. 
        Backed by robust tooling design, in-house mold maintenance, and strict process validation protocols, 
        we ensure <strong>consistency, efficiency, and minimal downtime.</strong> 
        In addition to molding, we offer <strong> end-to-end value-added services,</strong> 
        including <strong> mechanical and electronic assembly, in-line QC,</strong> and <strong> supply chain integration,</strong> 
        helping our customers reduce lead times and simplify vendor management. 
    </p> 

    <strong>Our Core Competencies</strong>
    <ul class="custom-bullet-list">
        <li *ngFor="let list of capabilities" > {{ list }} </li>
    </ul>

    <strong>Why Choose Funfigz Solution?</strong>
    <ul class="custom-bullet-list">
        <li *ngFor="let reason of reasonsToChoose" [innerHTML]="reason"> </li>
    </ul>

    <div class="contact-info">
        <span>
            <strong>Call:</strong> <a href= "tel:+919986748794">{{"+91 9986748794"}}</a>
        </span>
        <span>
            <strong>Email:</strong> <a href= "mailto:contact@funfigz.com">{{"contact@funfigz.com"}}</a>
        </span>
    </div>
  </div>